<template lang="pug">
SlideInPanel(:isOpen="sidePanelIsOpen" @close="$emit('close')")
  SlideInBaseTemplate(
    v-if="focusedItem"
    :title="focusedItem.NameInBriq"
    :allowEdit="allowEdit"
    @edit="event => $emit('edit', {item: focusedItem, event})"
    @close="$emit('close')"
  )
    BriqTable.dense(data-test-id="product-slide-in-table")
      tbody
        tr
          td.bold Key
          td {{ focusedItem.Key }}
        tr
          td.bold Resource
          td {{ focusedItem.ResourceName }}
        tr
          td.bold Product name
          td {{ focusedItem.NameInBriq }}
        tr(v-if="isFocusedItemNotScheduledInParallel")
          td.bold Resource duration
          td {{ resourceDurationInMinutes }}
        tr(v-if="isFocusedItemNotScheduledInParallel" data-test-id="modified-duration")
          td.bold Modified duration
          td {{ modifiedDurationInMinutes }}
        tr(data-test-id="base-price")
          td.bold Base price
          td {{ basePrice }}
        tr(data-test-id="vat")
          td.bold VAT
          td {{ focusedItem.BasePrice.TaxName }}
        tr(data-test-id="available-online")
          td.bold Available online
          td {{ availableOnline }}
        tr(data-test-id="show-in-email")
          td.bold Show in e-mail
          td {{ showInProgram }}
        tr(data-test-id="status")
          td.bold Status
          td {{ status }}
        tr(data-test-id="used-in-deals")
          td.bold Used in deals
          td {{ focusedItem.RelatedDeals.length }}
        tr(v-if="hasError" data-test-id="product-error")
          td.bold Problems
          td.text(v-html="errors")
</template>

<script>
import { pipe, prop, ifElse } from 'ramda'
import SlideInPanel from '@v/components-global/layout/SlideInPanel.vue'
import SlideInBaseTemplate from '@v/components-global/layout/SlideInBaseTemplate.vue'
import { durationStringToSeconds } from '@/vue/util/isoDurationHelper.js'

export default {
  name: 'ProductSlideInPanel',
  components: { SlideInPanel, SlideInBaseTemplate },
  props: {
    focusedItem: Object,
    sidePanelIsOpen: Boolean,
    allowEdit: Boolean,
  },
  computed: {
    isFocusedItemNotScheduledInParallel() {
      return !this.focusedItem.ScheduleInParallel
    },
    modifiedDurationInMinutes() {
      return this.focusedItem && this.focusedItem.CustomDuration !== null
        ? durationStringToSeconds(this.focusedItem.CustomDuration) / 60
        : '-'
    },
    resourceDurationInMinutes() {
      return this.focusedItem && this.focusedItem.ResourceDuration !== null
        ? durationStringToSeconds(this.focusedItem.ResourceDuration) / 60
        : '-'
    },
    basePrice() {
      return pipe(
        ifElse(prop('DisplayIncludingTax'), prop('IncludingTax'), prop('ExcludingTax')),
        this.$formatCurrency,
      )(this.focusedItem.BasePrice)
    },
    availableOnline() {
      return this.parseBooleanValue('AvailableInFunnel')
    },
    showInProgram() {
      return this.parseBooleanValue('ShowInEmail')
    },
    status() {
      return this.focusedItem.Enabled ? 'Active' : 'Inactive'
    },
    hasError() {
      return this.focusedItem.Error !== null
    },
    errors() {
      return this.focusedItem.Error.Details.replace('\n', '<br/>')
    },
  },
  methods: {
    parseBooleanValue(property) {
      return this.focusedItem[property] ? 'Yes' : 'No'
    },
  },
}
</script>
